import { getMyself } from '@/api/profile'
import { objectToFormData } from '@/utils/helpers'
import { decodeToken } from '@/utils/helpers'
import { ref, computed } from 'vue'
import {
  setToken,
  setRefreshToken,
  removeToken,
  removeRefreshToken,
  getToken,
  getRefreshToken,
} from '@/utils/cookie'
import { useRouter } from 'vue-router'
import { getStorage, setStorage } from '@/utils/helpers'
import { VRIO_KEY } from '@/constants'
import { postAuthLogin } from '@/api/auth'
import { NOTIFICATION_KEY } from '@/constants'

const isVrio = ref(getStorage(VRIO_KEY) ? true : false)
const me = ref(null)

export default function useAuth() {
  const router = useRouter()

  const auth = async (payload) => {
    try {
      const formData = objectToFormData(payload)
      const resp = await postAuthLogin(formData)
      setTokens(resp)
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  const getMe = async () => {
    if (me.value) return

    try {
      const resp = await getMyself()
      me.value = resp
    } catch (error) {
      console.log(error)
      throw error
    }
  }

  /**
   * Проверяет валидность пароля
   * @returns {boolean}
   */
  const isTemporaryPassword = async () => {
    const token = getToken()
    const isValid = ref(true) // возвращаем false только при явном признаки не валидности пароля

    if (token) {
      try {
        const data = decodeToken(token)

        if (data.must_change_password) {
          isValid.value = false
        }
      } catch (error) {
        console.log(error)
      }
    }

    return isValid
  }

  /**
   * Проверяет, что пароль истек(пароль нужно обновить за 5 дней)
   * @returns {boolean}
   */
  const isCriticalExpiredPassword = computed(() => {
    if (me.value?.days_before_password_expires <= 5) return true
    return false
  })
  /**
   * Проверяет, что пароль скоро истекает
   * @returns {boolean}
   */
  const isExpireSoonPassword = computed(() => {
    if (me.value?.days_before_password_expires <= 21) return true
    return false
  })

  const setTokens = (payload) => {
    const { access_token, refresh_token } = payload

    if (access_token) {
      setToken(access_token)
    }

    if (refresh_token) {
      setRefreshToken(refresh_token)
    }
  }

  const getTokens = () => {
    const token = getToken()
    const refreshToken = getRefreshToken()

    return {
      token,
      refreshToken,
    }
  }

  const removeTokens = () => {
    removeToken()
    removeRefreshToken()
  }

  const setVrio = (state) => {
    setStorage(VRIO_KEY, state)
    isVrio.value = state
  }

  const logout = async () => {
    removeTokens()
    setVrio(false)
    localStorage.removeItem(NOTIFICATION_KEY) // удаляем информацию об показанных уведомлениях
    await router.push({ name: 'Auth' })
    // #3174
    // перезагружаем страницу, что бы сбросить profile, и заново расставить roles
    // реактивно сбросить не получилось, т.к. есть не реактивные roles, которые устанавливаются при первой авторизации
    location.reload()
  }

  return {
    me,
    auth,
    getMe,
    isTemporaryPassword,
    isCriticalExpiredPassword,
    isExpireSoonPassword,
    setTokens,
    getTokens,
    removeTokens,
    isVrio,
    setVrio,
    logout,
  }
}
